import { useTagsQuery } from './enrollment-types';

export const useSameDayTagId = () => {
  const {data} = useTagsQuery();
  return data?.tags.find(t => t.name.toLowerCase().includes('same'))?.id;
}
